export default {"src":"/_next/static/media/essentials.efe837dd.gif","height":36,"width":36,"blurWidth":0,"blurHeight":0};